<template>
<div class="chapter">
<div class="inner_page">
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<h1 class="block_1" id="toc_id_1">About the Author</h1>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_"> </p>
<p class="block_2">Kikisun was the first born to Mildred and John and the first grandchild to Fanny and Benson. She was pampered with love by the four of them. They taught her to pray, read and write long before she was five years old. After a sad incident at her grandparents’ homestead in Nerwande, her father cleared a space for her where she could read and write without being disturbed. It was difficult to keep creating such a place at their own house because the family kept moving. She herself attended a total of eight schools, from year 1 to year 11. Her father, therefore, advised and helped her to recreate that place at Nerwande, with its beautiful views in her mind. Now, that image is so imbedded in her and keeps popping up unexpectedly.</p>
<p class="block_3" id="calibre_pb_0"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_000.vue?cb0b8d0a